// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","subscriptionTypeContainer":"_1-zCHwylltaxZyB1QwFqFi","toggleSwitchContainer":"_2cqyjYcy5jFn6vjxU4QH0y","renewalDateInformation":"_36WKvnCClmBzrK8TavssbU"};